angular.module('mychart').controller('VisitSummaryCtrl',
    [
        '_', 
        '$scope', 
        'MyChartService', 
        'PatientPortalStorageRepository', 
        '$uibModal', 
        'PersonRepository', 
        'moment', 
        'aprgettext', 
        'toaster',
        'BrowserService',
        'WebDocumentHelper',
        function (
            _, 
            $scope, 
            MyChartService, 
            PatientPortalStorageRepository, 
            $modal, 
            PersonRepository, 
            moment, 
            gettext, 
            toaster,
            BrowserService,
            WebDocumentHelper
        ) {
            'use strict';

            $scope.name = 'VisitSummary';
            $scope.numVisits = 0;
            $scope.loading = true;
            $scope.selectedVisit = {
                Id: null,
                FileName: 'VisitSummary'
            };

            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            var updateUsageMetricDto = {
                MetricTypeName: '170.315(e)(1) - View, Download, and Transmit to 3rd Party',
                MetricSubTypeName: 'Success',
                IncrementFactor: 1,
            };

            function onLoad() {
                $scope.loading = true;
                $scope.removeHttpError();

                var usageMetricSubTypeName = 'Success';
                MyChartService
                    .getVisitSummaries(activePatient.id)
                    .then(function (data) {
                        $scope.visits = _(data.plain()).map(function (entry) {
                            return _.assign(entry, {Downloading : false});
                        }).value();
                        $scope.numVisits = data.length;
                    })
                    .catch(function (response) {
                        usageMetricSubTypeName = 'Failure';
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        updateUsageMetric(usageMetricSubTypeName);
                        $scope.loading = false;
                    });
                auditMedicalHistory(reportRequestDto);
            }

            function viewVisitSummary(visitId, visitDate) {
                auditClinicalSummary(reportRequestDto);
                $scope.isModalDisplayed = true;

                var modalConfig = {
                    Title: gettext('Visit Summary: ') + moment(visitDate).format('LL'),
                    DownloadFileName: activePatient.firstName + activePatient.lastName + '_VisitSummary',
                    PatientId: activePatient.id,
                    DocumentId: visitId,
                    DocumentLoad: getVisitSummary,
                    DocumentDownload: downloadVisitSummary,
                    GetStaticUrl: getVisitSummaryUrl,
                    HasStaticUrl: true,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                    DocumentHelper: WebDocumentHelper
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }

            function getVisitSummary(documentId){
                return PersonRepository.getVisitSummary(activePatient.id, documentId);
            }

            function getVisitSummaryUrl(documentId) {
                return PersonRepository.getVisitSummaryUrl(activePatient.id, documentId);
            }

            function downloadVisitSummary(documentId){
                auditClinicalSummary(reportRequestDto);
                var usageMetricSubTypeName = 'Success';
                return PersonRepository.getVisitSummary(activePatient.id, documentId)
                    .then(function (data) {
                        return {Data: data.Data, Extension: 'pdf'};
                    })
                    .catch(function () {
                        usageMetricSubTypeName = 'Failure';
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function () {
                        updateUsageMetric(usageMetricSubTypeName);
                    });
            }

            function downloadVisitSummaryByVisit(visit, visitDate){
                auditClinicalSummary(reportRequestDto);
                visit.Downloading = true;
                $scope.selectedVisit.FileName += moment(visitDate).format('l');
                $scope.selectedVisit.Id = visit.VisitId;

                var usageMetricSubTypeName = 'Success';
                return PersonRepository.getVisitSummary(activePatient.id, visit.VisitId)
                    .then(function (data) {
                        return {Data: data.Data, FileName: $scope.selectedVisit.FileName, Extension: 'pdf'};
                    })
                    .catch(function () {
                        usageMetricSubTypeName = 'Failure';
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function() {
                        updateUsageMetric(usageMetricSubTypeName);
                        visit.Downloading = false;
                    });
            }

            function auditMedicalHistory(reportRequestDto) {
                MyChartService.auditMedicalHistoryLogging(reportRequestDto);
            }

            function auditClinicalSummary(reportRequestDto) {
                MyChartService.auditClinicalSummaryLogging(reportRequestDto);
            }

            function updateUsageMetric(metricSubTypeName) {
                updateUsageMetricDto.MetricSubTypeName = metricSubTypeName;
                MyChartService.usageMetricLogging(updateUsageMetricDto);
            }

            onLoad();
            $scope.auditClinicalSummary = auditClinicalSummary;
            $scope.auditMedicalHistory = auditMedicalHistory;
            $scope.viewVisitSummary = viewVisitSummary;
            $scope.downloadVisitSummary = downloadVisitSummary;
            $scope.downloadVisitSummaryByVisit = downloadVisitSummaryByVisit;
        }]);